// ** React Imports
import ReactDOM from 'react-dom';
import { Suspense, lazy } from 'react';
import { BrowserRouter } from 'react-router-dom';

// ** Redux Imports
import { store } from './shared/redux/store';
import { Provider } from 'react-redux';

// ** ThemeColors Context

import { ThemeContext } from './shared/lib/utility/context/ThemeColors';

// ** ThemeConfig
import themeConfig from './shared/configs/themeConfig';

// ** Toast
import toast, { Toaster } from 'react-hot-toast';

// ** Spinner (Splash Screen)
import Spinner from '@components/spinner/Fallback-spinner';

// ** Ripple Button
import '@components/ripple-button';

// ** PrismJS
import 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';
import 'prismjs/components/prism-jsx.min';

// ** React Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css';

// ** React Hot Toast Styles
import '@styles/react/libs/react-hot-toasts/react-hot-toasts.scss';

// ** Core styles
import '@assets/fonts/feather/iconfont.css';
import '@shared/@core/scss/core.scss';
import './shared/assets/scss/style.scss';

// ** Service Worker
import * as serviceWorker from './serviceWorker';
import { isLoggedIn } from './shared/redux/auth';


// ** Lazy load app
const LazyApp = lazy(() => import('./App'));

// Пробуем восстановить сессию только если есть токен. Иначе — сразу логин,
// без лишнего запроса профиля.
if (localStorage.getItem('token')) {
  store.dispatch(isLoggedIn());
}

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <Suspense fallback={<Spinner />}>
        <ThemeContext>
          <LazyApp />
          <Toaster
            position={themeConfig.layout.toastPosition}
            toastOptions={{ className: 'react-hot-toast' }}
          />
        </ThemeContext>
      </Suspense>
    </Provider>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
